/** @file The command a vertex drag commits: setup rest positions, or a deform key at the playhead in Animate. */
import type { CommandCall, Id } from '@pose2d/format/types';

/** Where a vertex drag writes: the mesh, the editor mode and (Animate) the animation and frame. */
export interface VertexEdit {
  attachment: Id;
  mode: 'setup' | 'animate';
  animation: Id | null;
  frame: number;
}

/**
 * Setup: `mesh.setVertices` (with `uvs` when the image stays in place). Animate: `animation.setDeformKey` with the full
 * offsets from 0 (the command trims them; all zero stores the rest key). No animation → no call.
 */
export function vertexEditCalls(edit: VertexEdit, values: readonly number[], uvs: readonly number[] | null): CommandCall[] {
  if (edit.mode === 'setup') {
    return [{ name: 'mesh.setVertices', input: { target: edit.attachment, vertices: [...values], ...(uvs === null ? {} : { uvs: [...uvs] }) } }];
  }
  if (edit.animation === null) return [];
  const offsets = { start: 0, values: [...values] };
  return [{ name: 'animation.setDeformKey', input: { animation: edit.animation, attachment: edit.attachment, frame: edit.frame, offsets } }];
}
